/*
================================================================================
|                                                                              |
|  FILE: src/sections/ecorevivepage/EcoReviveHero.js                           |
|  PURPOSE: Hero section for the EcoRevive page with single image.            |
|                                                                              |
================================================================================
*/
import React from 'react';

export default function EcoReviveHero() {
    return (
        <section className="relative w-full h-screen min-h-[600px] bg-gray-100 overflow-hidden">
            <div className="absolute inset-0">
                <img 
                    src="/images/environmental_.webp" 
                    alt="Project EcoRevive - Environmental Recovery" 
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent" />
            </div>
            
            <div className="absolute inset-0 z-10 flex flex-col justify-end">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-32 text-left">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                        Project EcoRevive
                    </h1>
                    <p className="mt-6 text-xl text-gray-200 max-w-3xl animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                        Environmental Recovery in Action - Healing the scars of illegal mining in the Apamprama forest reserve and surrounding communities in Ghana.
                    </p>
                    <div className="mt-10 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                        <a href="#sdg-showcase" className="inline-block px-8 py-4 rounded-full bg-[#3bb8ff] text-white font-bold shadow-lg hover:bg-blue-500 transition-all text-base transform hover:scale-105">
                            View SDG Impact
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
} 